import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=7baa5452"
import script from "./TaskForm.vue?vue&type=script&lang=js"
export * from "./TaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports